// Module-level tr() for components that render English strings inline. LanguageProvider sets the
// current language during its render, before any child renders, so a tr() call inside a component
// render returns the visitor's language. Never call tr() at module scope (it would freeze English);
// call it where the string is rendered.
import type { LanguageCode } from '../types/language';
import { tr as translateText } from '../utils/i18n';

let currentLanguage: LanguageCode = 'en';

export function setCurrentLanguage(lang: LanguageCode) {
  currentLanguage = lang;
}

export function tr(text: string, params?: Record<string, string | number>): string {
  return translateText(text, currentLanguage, params);
}
